module.exports = __webpack_public_path__ + "static/img/image075.423b232.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news7/image075.png
// module id = AgyT
// module chunks = 1